import type { CollectionKey, ConstellationKey, ItemKey } from '@toolproof-core/visualization/_contract/key';

function toStablePathSegment(path: string): string {
    if (path === '.') return 'root';
    return path.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'root';
}

export function toNodeItemKey(path: string): ItemKey<'entity'> {
    return `item:entity:core:${toStablePathSegment(path)}`;
}

export function toRootCollectionKey(): CollectionKey<'entity'> {
    return 'collection:entity:core:root';
}

export function toDirectoryChildCollectionKey(path: string): CollectionKey<'entity'> {
    return `collection:entity:core:${toStablePathSegment(path)}:children`;
}

export function toDirectoryConstellationKey(path: string): ConstellationKey<'entity'> {
    return `constellation:entity:core:${toStablePathSegment(path)}:children`;
}

export function toRootConstellationKey(): ConstellationKey<'entity'> {
    return 'constellation:entity:core:root';
}